module.exports = __webpack_public_path__ + "static/8.3_ancient_china-7102a397450ccfad1e96d6e1a3add276.pdf";